import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import PropTypes from "prop-types";
const EditPayoutSettingsModal = ({
  show,
  onHide,
  payoutSettings,
  saveSettings,
}) => {
  const [settings, setSettings] = useState(payoutSettings);

  const handleChange = (e, status, field) => {
    const value = field === "limit" ? Number(e.target.value) : e.target.value;
    setSettings({
      ...settings,
      [status]: {
        ...settings[status],
        [field]: value,
      },
    });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Редактирование настроек выплат</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {Object.keys(settings).map((status) => (
          <Form.Group className="mb-3" key={status}>
            <Form.Label>
              <strong>{status}</strong>
            </Form.Label>
            <Form.Control
              type="number"
              placeholder="Лимит"
              value={settings[status].limit || ""}
              onChange={(e) => handleChange(e, status, "limit")}
              className="mb-2"
            />
            <Form.Control
              type="number"
              placeholder="Процент"
              value={settings[status].percentage || ""}
              onChange={(e) => handleChange(e, status, "percentage")}
            />
          </Form.Group>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Отмена
        </Button>
        <Button variant="primary" onClick={() => saveSettings(settings)}>
          Сохранить
        </Button>
      </Modal.Footer>
    </Modal>
  );
  
};
EditPayoutSettingsModal.propTypes = {
  show: PropTypes.bool.isRequired, // show должен быть булевым значением
  onHide: PropTypes.func.isRequired, // onHide должен быть функцией
  payoutSettings: PropTypes.object.isRequired, // payoutSettings должен быть объектом
  saveSettings: PropTypes.func.isRequired, // saveSettings должен быть функцией
};

export default EditPayoutSettingsModal;
